export const checkAccessLandingMobilePage = () => {
  const isMobile = window.navigator.userAgent.includes('Mobile')
  const exist = window.localStorage.getItem('landing_mobile_exist')

  if (isMobile && !exist) return true

  return false
}
